import { LocalizedLabel } from '@mews-commander/ui';
import { NestedCard, NestedCardVariant, Stack } from '@optimus-web/core';

interface DashboardCardProps {
    variant?: NestedCardVariant;
    button?: React.ReactNode;
    textKey: Mews.TextKey;
    content: React.ReactNode;
}
export const DashboardCard = ({ variant, textKey, content, button, ...other }: DashboardCardProps) => (
    <NestedCard variant={variant} {...other}>
        <Stack distribution="space-between">
            <Stack spacing="100" vertical>
                <LocalizedLabel textKey={textKey} as="div" />
                {content}
            </Stack>

            {button && (
                <Stack vertical alignment="center">
                    {button}
                </Stack>
            )}
        </Stack>
    </NestedCard>
);
